<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-3">
          <li class="breadcrumb-item">
            <a
              href="#"
              @click.prevent="$router.go(-1)"
            >
              <feather type="arrow-left" />
              {{ $t('editRequest.geri') }}
            </a>
          </li>
        </ol>
      </div>
    </div>
    <div class="clearfix" />
    <!-- Container-fluid starts-->
    <div
      v-if="request"
      class="container"
    >
      <h3 class="mb-3">
        #{{ request.requestType }}{{ buildLongId(request.id) }}
      </h3>


      <input
        id="fileInput"
        ref="file"
        type="file"
        style="display: none"
        @change="setPhoto"
      >

      <div
        v-if="['RFI','RFQ','PQT', 'REV','AUC'].indexOf(request.requestType)>-1
          || (request.requestType==='OFR' && profile !== 'LOGISTIC') "
        class="card shadow"
      >
        <div class="card-body">
          <h4>
            <span v-if="request.requestType==='AUC'">{{ $t('newAUCRequest.hrracnzHansSahyAiddir') }}</span>
            <span v-else-if="request.requestType==='REV'">{{ $t('newRevRequest.ksHrracnzHansSahyAiddir') }}</span>
            <span v-else-if="request.requestType==='OFR'">{{ $t('newOfferRequest.tklifinizHansSahyAiddir') }}</span>
            <span v-else>{{ $t('newInfoRequest.sorunuzHansSahyAiddir') }}</span>
          </h4>

          <p>
            {{ $t('newAUCRequest.sorununYaradarknFaliyytSahsiniSemkMtlqdirSizMaximu') }}
          </p>

          <div class="mt-3">
            <button
              v-b-modal.modal-sector-selection
              type="button"
              class="btn btn-sm btn-light-primary"
            >
              {{ $t('companyProfile.faliyytSahsiniSein') }}
            </button>
          </div>

          <hr v-if="requestSectors.length>0">
          <SelectedSectorView
            :sectors="requestSectors"
            :parent-id="0"
          />
        </div>
      </div>
      <form @submit.prevent="createRequest">
        <div class="card shadow">
          <div class="card-body">
            <div class="mb-3">
              <label v-if="['REV','AUC'].indexOf(request.requestType)>-1"> {{ $t('newAUCRequest.hrracnAd') }}</label>
              <label v-else-if="['POL'].indexOf(request.requestType)>-1"> {{
                $t('newPolRequest.ssvermMvzusununBal')
              }}</label>
              <label v-else-if="['ORF'].indexOf(request.requestType)>-1"> {{ $t('editRequest.tklifinBal') }}</label>
              <label v-else>{{ $t('newInfoRequest.soruBal') }}</label>
              <b-form-input
                id="new_request_title"
                v-model="requestTitle"
                type="text"
                required
              />
            </div>

            <div
              v-if="['LOG','TRS','TRS','TRK'].indexOf(request.requestType)===-1"
              class="mb-3"
            >
              <span v-if="['REV','AUC'].indexOf(request.requestType)>-1">{{
                $t('editRequest.hrracBarddMlumatlar')
              }}</span>
              <span v-else-if="['POL'].indexOf(request.requestType)>-1">{{
                $t('newPolRequest.ssvermMvzusununMtni')
              }}</span>
              <span v-else-if="['OFR'].indexOf(request.requestType)>-1">{{ $t('editRequest.tklifMtni') }}</span>
              <span v-else>{{ $t('newInfoRequest.soruMtni') }}</span>
              <b-form-textarea
                id="new_request_description"
                v-model="requestDescription"
                required
                rows="4"
              />
            </div>
          </div>
        </div>


        <div
          v-if="requestType === 'PQT'"
          class="card shadow"
        >
          <div class="card-body">
            <h4>{{ $t('newRFQRequest.ilkinZruriTlblr') }}</h4>
            <hr>
            <div class="mb-3">
              <label>{{ $t('newRFQRequest.valyuta') }}</label>
              <div class="row">
                <div class="col-md-3">
                  <select
                    v-model="orderExtras.currency"
                    class="form-control"
                    min="1"
                    required
                  >
                    <option value="AZN">
                      {{ $t('newAUCRequest.azn') }}
                    </option>
                    <option value="USD">
                      {{ $t('newRFQRequest.usd') }}
                    </option>
                    <option value="EUR">
                      {{ $t('newRFQRequest.eur') }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4 d-flex align-items-center">
                  <div class="radio radio-primary d-inline-block">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        id="currencyRequiredYes"
                        v-model="orderExtras.currencyRequired"
                        type="radio"
                        name="currency"
                        class="custom-control-input"
                        value="true"
                        required
                      >
                      <label
                        class="custom-control-label"
                        for="currencyRequiredYes"
                      >{{ $t('pqtExtrasView.mtlq') }}</label>
                    </div>
                  </div>
                  <div class="radio radio-primary d-inline-block">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="currencyRequiredNo"
                        v-model="orderExtras.currencyRequired"
                        type="radio"
                        name="currency"
                        class="custom-control-input"
                        value="false"
                      >
                      <label
                        class="custom-control-label"
                        for="currencyRequiredNo"
                      >{{ $t('pqtExtrasView.arzuOlunan') }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <!-- Delivery Required? -->
              <label>{{ $t('newRFQRequest.atdrlma') }}</label>
              <div class="row">
                <div class="col-md-3">
                  <div class="radio radio-primary">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="deliveryYes"
                        v-model="orderExtras.deliveryNeeded"
                        type="radio"
                        value="true"
                        class="custom-control-input"
                      >
                      <label
                        class="custom-control-label"
                        for="deliveryYes"
                      >
                        {{ $t('newRFQRequest.yes') }}
                      </label>
                    </div>
                  </div>
                  <div class="radio radio-primary">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="deliveryNo"
                        v-model="orderExtras.deliveryNeeded"
                        type="radio"
                        value="false"
                        class="custom-control-input"
                      >
                      <label
                        class="custom-control-label"
                        for="deliveryNo"
                      >
                        {{ $t('newRFQRequest.no') }}
                      </label>
                    </div>
                  </div>
                </div>

                <div
                  v-if="orderExtras.deliveryNeeded === 'true'"
                  class="col-md-4"
                >
                  <div class="input-group">
                    <input
                      v-model="orderExtras.deliveryAddress"
                      type="text"
                      class="form-control"
                      :placeholder="$t('newRFQRequest.enterAddress')"
                      required
                    >
                    <button
                      class="btn btn-outline-secondary"
                      @click.prevent="$bvModal.show('modal-address-history-edit')"
                    >
                      📜
                    </button>
                  </div>
                </div>
                <!-- Delivery Date Required? -->
                <div
                  v-if="orderExtras.deliveryNeeded === 'true'"
                  class="col-md-4"
                >
                  <label>{{ $t('newRFQRequest.deliveryTimeRequest') }}</label>
                  <div class="radio radio-primary">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="timeYes"
                        v-model="orderExtras.deliveryTimeNeeded"
                        type="radio"
                        value="true"
                        class="custom-control-input"
                      >
                      <label
                        class="custom-control-label"
                        for="timeYes"
                      >
                        {{ $t('newRFQRequest.lazmdr') }}
                      </label>
                    </div>
                  </div>
                  <div class="radio radio-primary ">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="timeNo"
                        v-model="orderExtras.deliveryTimeNeeded"
                        type="radio"
                        value="false"
                        class="custom-control-input"
                      >
                      <label
                        class="custom-control-label"
                        for="timeNo"
                      >
                        {{ $t('newRFQRequest.lazmDeyil') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Address History Modal -->
              <b-modal
                id="modal-address-history-edit"
                centered
                footer-class="hidden"
                size="lg"
                :title="$t('newRFQRequest.selectAddress')"
                scrollable
                class="theme-modal"
                @hidden="resetForm"
              >
                <!-- Address List -->
                <ul class="list-group">
                  <li
                    v-for="(address) in savedAddresses"
                    :key="address.id"
                    class="list-group-item d-flex justify-content-between align-items-center selectable-address"
                    @click="selectAddress(address)"
                  >
                    <!-- Address divi -->
                    <div>
                      {{ address.address }}
                    </div>
                    <!-- Düymələr -->
                    <div>
                      <b-button
                        variant="outline-secondary"
                        size="sm"
                        class="mr-2"
                        @click.stop="editAddress(address)"
                      >
                        ✏️
                      </b-button>
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        @click.stop="deleteAddress(address.id)"
                      >
                        ❌
                      </b-button>
                    </div>
                  </li>
                </ul>
                <hr>
                <!-- Add/Edit Form -->
                <div>
                  <b-form @submit.prevent="handleSubmit">
                    <b-form-group :label="formMode === 'add' ? $t('newRFQRequest.addAddress') : $t('newRFQRequest.editAddress')">
                      <b-form-input
                        v-model="addressInput"
                        :placeholder="$t('newRFQRequest.enterAddress')"
                        required
                      />
                    </b-form-group>

                    <b-button
                      variant="success"
                      type="submit"
                    >
                      {{ formMode === 'add' ? $t('newRFQRequest.create') : $t('newRFQRequest.update') }}
                    </b-button>
                    <b-button
                      v-if="formMode === 'edit'"
                      variant="secondary"
                      class="ml-2"
                      @click="resetForm"
                    >
                      {{ $t('companyProfile.lvEt') }}
                    </b-button>
                  </b-form>
                </div>
              </b-modal>
            </div>
            <hr>
            <div class="mb-3">
              <div class="row">
                <div class="col-md-4">
                  <label>{{ $t('newRFQRequest.dniSulu') }}</label>
                  <div class="radio radio-primary">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="paymentRequiredYes"
                        v-model="orderExtras.paymentRequired"
                        type="radio"
                        name="payment"
                        class="custom-control-input"
                        value="true"
                        required
                      >
                      <label
                        class="custom-control-label"
                        for="paymentRequiredYes"
                      >{{ $t('newRFQRequest.yes') }}</label>
                    </div>
                  </div>
                  <div class="radio radio-primary ">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="paymentRequiredNo"
                        v-model="orderExtras.paymentRequired"
                        type="radio"
                        name="payment"
                        class="custom-control-input"
                        value="false"
                      >
                      <label
                        class="custom-control-label"
                        for="paymentRequiredNo"
                      >{{ $t('newRFQRequest.no') }}</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="orderExtras.paymentRequired === 'true'"
                  class="col-md-4"
                >
                  <label>{{ $t('newRFQRequest.paymentRequirements') }}</label>
                  <div class="radio radio-primary">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="paymentRequirements30100"
                        type="radio"
                        disabled
                        name="paymentRequirements"
                        class="custom-control-input"
                        value="paymentRequirements30100"
                        required
                      >
                      <label
                        class="custom-control-label"
                        for="paymentRequirements30100"
                      >{{ $t("newRFQRequest.paymentRequirements30100") }}</label>
                    </div>
                  </div>
                  <div class="radio radio-primary ">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="paymentRequirements100"
                        type="radio"
                        name="paymentRequirements"
                        class="custom-control-input"
                        value="paymentRequirements100"
                        disabled
                      >
                      <label
                        class="custom-control-label"
                        for="paymentRequirements100"
                      >{{ $t("newRFQRequest.paymentRequirements100") }}</label>
                    </div>
                  </div>
                  <div class="radio radio-primary ">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="paymentRequirementsPercent"
                        type="radio"
                        name="paymentRequirements"
                        class="custom-control-input"
                        value="paymentRequirementsPercent"
                        disabled
                      >
                      <label
                        class="custom-control-label"
                        for="paymentRequirementsPercent"
                      >{{ $t('newRFQRequest.paymentRequirementsPercent') }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="mb-3">
              <div class="row">
                <div class="col-md-4">
                  <label>{{ $t('newRFQRequest.guarantyTime') }}</label>

                  <div class="radio radio-primary">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="guarantyTimeYes"
                        v-model="orderExtras.guarantyTime"
                        type="radio"
                        name="guarantyTime"
                        class="custom-control-input"
                        value="true"
                        required
                      >
                      <label
                        class="custom-control-label"
                        for="guarantyTimeYes"
                      >{{ $t('newRFQRequest.yes') }}</label>
                    </div>
                  </div>
                  <div class="radio radio-primary ">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="guarantyTimeNo"
                        v-model="orderExtras.guarantyTime"
                        type="radio"
                        name="guarantyTime"
                        class="custom-control-input"
                        value="false"
                      >
                      <label
                        class="custom-control-label"
                        for="guarantyTimeNo"
                      >{{ $t('newRFQRequest.no') }}</label>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-4"
                >
                  <label>{{ $t('newRFQRequest.countryRequired') }}</label>
                  <div class="radio radio-primary">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="countryRequiredYes"
                        v-model="orderExtras.countryRequired"
                        type="radio"
                        name="countryRequired"
                        class="custom-control-input"
                        value="true"
                        required
                      >
                      <label
                        class="custom-control-label"
                        for="countryRequiredYes"
                      >{{ $t('newRFQRequest.yes') }}</label>
                    </div>
                  </div>
                  <div class="radio radio-primary ">
                    <div class="custom-control custom-radio custom-control-inline ml-3">
                      <input
                        id="countryRequiredNo"
                        v-model="orderExtras.countryRequired"
                        type="radio"
                        name="countryRequired"
                        class="custom-control-input"
                        value="false"
                      >
                      <label
                        class="custom-control-label"
                        for="countryRequiredNo"
                      >{{ $t("newRFQRequest.no") }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label>{{ $t('newRFQRequest.ilkinZruriTlblrlBalQeydlr') }}</label>

              <div>
                <textarea
                  v-model.trim="orderExtras.initialRequirementNotes"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="request.requestType === 'AUC'"
          class="card shadow"
        >
          <div class="card-body">
            <div class="mb-3 w-50">
              <label>{{ $t('newAUCRequest.balancQiymt') }}</label>
              <div class="input-group">
                <b-form-input
                  v-model="orderExtras.startingPrice"
                  type="number"
                  min="1"
                  required
                />
                <div class="input-group-append">
                  <div class="input-group-text">
                    {{ $t('newAUCRequest.azn') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="request.requestType === 'POL'"
          class="card shadow"
        >
          <div class="card-body">
            <div class="mb-3">
              <label>{{ $t('newPolRequest.birNeCavabSeilBilrmi') }}</label>
              <br>
              <div class="ml-2">
                <div class="radio radio-primary d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      id="multiSelectYes"
                      v-model="orderExtras.multiSelect"
                      type="radio"
                      name="multiSelect"
                      class="custom-control-input"
                      :value="1"
                    >
                    <label
                      class="custom-control-label"
                      for="multiSelectYes"
                    >{{ $t('newPolRequest.bli') }}</label>
                  </div>
                </div>
                <div class="radio radio-primary d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline ml-3">
                    <input
                      id="multiSelectNo"
                      v-model="orderExtras.multiSelect"
                      type="radio"
                      name="multiSelect"
                      class="custom-control-input"
                      :value="0"
                    >
                    <label
                      class="custom-control-label"
                      for="multiSelectNo"
                    >{{ $t('newPolRequest.xeyr') }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label>{{ $t('newPolRequest.istifadiZCavabVariantnLavEdBilrmi') }}</label>
              <br>
              <div class="ml-2">
                <div class="radio radio-primary d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      id="ownVariantYes"
                      v-model="orderExtras.ownVariant"
                      type="radio"
                      name="ownVariant"
                      class="custom-control-input"
                      :value="1"
                    >
                    <label
                      class="custom-control-label"
                      for="ownVariantYes"
                    >{{ $t('newPolRequest.bli') }}</label>
                  </div>
                </div>
                <div class="radio radio-primary d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline ml-3">
                    <input
                      id="ownVariantNo"
                      v-model="orderExtras.ownVariant"
                      type="radio"
                      name="ownVariant"
                      class="custom-control-input"
                      :value="0"
                    >
                    <label
                      class="custom-control-label"
                      for="ownVariantNo"
                    >{{ $t('newPolRequest.xeyr') }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="request.requestType === 'LOG'">
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newLogisticRequest.balancMntqVYolaDmTarixi') }}</h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('nvanIstiqamt') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpAddress"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4>
                {{ $t('newLogisticRequest.sonMntq') }}
              </h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('nvanIstiqamt') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffAddress"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow">
            <div class="card-body">
              <div class="mb-3">
                <label>{{ $t('newLogisticRequest.sorununDvriliyiVDigrQeydlr') }}</label>
                <b-form-textarea
                  v-model="orderExtras.notes"
                  required
                  rows="4"
                />
              </div>

              <div class="w-50">
                <div class="mb-3">
                  <label>{{ $t('newLogisticRequest.satcIlRazladnzIncotermsRti') }}</label>
                  <select
                    v-model="orderExtras.incoterms"
                    class="form-control"
                    required
                  >
                    <option
                      v-for=" i in inctermsList"
                      :key="i"
                      :value="i"
                    >
                      {{ i }}
                    </option>
                  </select>
                </div>

                <div class="mb-3">
                  <label>{{ $t('newLogisticRequest.hansNvDanmalarNTklifAlmaqIstyirsiniz') }}</label>

                  <multiselect
                    v-model="orderExtras.types"
                    :placeholder="$t('newLogisticRequest.danmaNvnSein')"
                    :label="$t('newLogisticRequest.value')"
                    track-by="key"
                    :options="typeList"
                    :multiple="true"
                  />
                  <div class="text-secondary ml-1">
                    {{ $t('newLogisticRequest.birNeDanmaNvSeBilrsiniz') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="request.requestType === 'TRS'">
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newLogisticRequest.balancMntqVYolaDmTarixi') }}</h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('nvanIstiqamt') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpAddress"
                      type="text"
                    />
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newTRSRequest.yknXacaTarix') }}</label>
                    <DatePicker
                      v-model="orderExtras.deadline"
                      mode="date"

                      :min-date="minDeadline"
                      :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                      :is-required="true"
                      :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                    >
                      <template #default="{ inputValue, inputEvents }">
                        <input
                          type="text"
                          class="form-control "
                          :value="inputValue"
                          placeholder=""
                          required
                          v-on="inputEvents"
                        >
                      </template>
                    </DatePicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4>
                {{ $t('newLogisticRequest.sonMntq') }}
              </h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('nvanIstiqamt') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffAddress"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="request.requestType === 'TRK'">
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newLogisticRequest.balancMntqVYolaDmTarixi') }}</h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.yolaDmTarixi') }}</label>
                    <DatePicker
                      v-model="orderExtras.deadline"
                      mode="date"
                      :min-date="minDeadline"
                      :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                      :is-required="true"
                      :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                    >
                      <template #default="{ inputValue, inputEvents }">
                        <input
                          type="text"
                          class="form-control "
                          :value="inputValue"
                          placeholder=""
                          required
                          v-on="inputEvents"
                        >
                      </template>
                    </DatePicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newLogisticRequest.sonMntq') }}</h4>
              <hr>

              <div class=" row ">
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCity"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.qeydlr') }}</label>

                    <b-form-textarea
                      v-model="requestDescription"
                      rows="3"
                      required
                    />
                    <span class="text-secondary">{{ $t('newTRKRequest.yolStYkGtrlBilckHrlrinAdnQeydEdBilrsiz') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newTRKRequest.ykHaqqndaMlumatlar') }}</h4>
              <hr>

              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.ykQbulEdckTrnNv') }}</label>

                    <multiselect
                      v-model="orderExtras.truckType"
                      :placeholder="$t('newTRKRequest.trNvnSein')"
                      :label="$t('newTRKRequest.name')"
                      track-by="key"
                      :options="truckTypeList"
                      :multiple="false"
                    >
                      <template
                        slot="singleLabel"
                        slot-scope="props"
                      >
                        <div style="line-height: 1.4; font-size: 12px;">
                          <strong>{{ props.option.name }}</strong> <br>
                          <span style="white-space: pre">{{ props.option.description }}</span>
                        </div>
                      </template>


                      <template
                        slot="option"
                        slot-scope="props"
                      >
                        <div style="line-height: 1.4; font-size: 12px;">
                          <strong>{{ props.option.name }}</strong> <br>
                          <span style="white-space: pre">{{ props.option.description }}</span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>

                <div class="col-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.hansNvYklrQbulEdilir') }}</label>

                    <multiselect
                      v-model="orderExtras.types"
                      :placeholder="$t('newTRKRequest.ykNvnSein')"
                      :label="$t('newLogisticRequest.value')"
                      track-by="key"
                      :options="advTypeList"
                      :multiple="true"
                    />
                  </div>
                </div>

                <div
                  v-if="orderExtras.types.find(t=>t.key==='dangerous')"
                  class="col-12"
                >
                  <div class="mb-3 ml-2">
                    <div class="checkbox checkbox-success">
                      <b-form-checkbox
                        v-model="orderExtras.driverHasAdr"
                        :value="1"
                      >
                        {{ $t('newTRKRequest.srcnnAdrIcazsiVarm') }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>


                <div class="col-md-6">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.yknMiqdar') }}</label>
                    <b-form-input
                      v-model.number="orderExtras.loadSize"
                      type="number"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label>{{ $t('newOfferRequest.lVahidi') }}</label>
                    <select
                      v-model="orderExtras.loadUnit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in loadUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.danmaQiymti') }}</label>

                    <div class="input-group">
                      <b-form-input
                        v-model.number="orderExtras.priceVolume"
                        type="number"
                        step="0.01"
                        required
                      />
                      <div class="input-group-text">
                        {{ $t('newTRKRequest.n', {expr: orderExtras.loadUnit || '-'}) }}
                      </div>

                      <b-form-input
                        v-model.number="orderExtras.pricePrice"
                        type="number"
                        step="0.01"
                        required
                      />
                      <div class="input-group-text">
                        {{ $t('newAUCRequest.azn') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.qiymtlBalQeydlr') }}</label>

                    <b-form-textarea
                      v-model="orderExtras.priceNotes"
                      rows="3"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="requestType === 'OFR'"
          class="card shadow"
        >
          <div class="card-body">
            <h4>{{ $t('newOfferRequest.tklifDetallar') }}</h4>
            <hr>

            <div class="w-50">
              <div v-if="requestSubType==='wholesale'">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-sm-6 mb-3">
                      <label> {{ $t('newOfferRequest.minimumSifariMiqdar') }}</label>
                      <b-form-input
                        v-model.number="orderExtras.minOrder"
                        type="number"
                        required
                      />
                    </div>
                    <div class="col-sm-6 mb-3">
                      <label>{{ $t('newOfferRequest.lVahidi') }}</label>
                      <select
                        v-model="orderExtras.unit"
                        class="form-control"
                        required
                      >
                        <option
                          v-for="v in loadUnits"
                          :key="v"
                          :value="v"
                        >
                          {{ v }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class=" mb-3">
                    <label> {{ $t('newOfferRequest.topdanSatQiymti1N', {unit: orderExtras.unit}) }}</label>
                    <div class="input-group">
                      <b-form-input
                        v-model.number="orderExtras.price"
                        type="number"
                        required
                      />
                      <div class="input-group-text">
                        <strong>{{ $t('newAUCRequest.azn') }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6 mb-3">
                  <label> {{ $t('newOfferRequest.dniSulu') }}</label>
                  <select
                    v-model="orderExtras.payment"
                    class="form-control"
                    required
                  >
                    <option value="transfer">
                      {{ $t('offerExtrasView.krm') }}
                    </option>
                    <option value="cash">
                      {{ $t('offerExtrasView.nad') }}
                    </option>
                    <option value="both">
                      {{ $t('offerExtrasView.hrIkisi') }}
                    </option>
                  </select>
                </div>
                <div
                  v-if="requestSubType!=='service' && requestSubType !==''"
                  class="col-sm-6 mb-3"
                >
                  <label> {{ $t('newOfferRequest.atdrlma') }}</label>
                  <select
                    v-model="orderExtras.delivery"
                    class="form-control"
                    required
                  >
                    <option value="no">
                      {{ $t('offerExtrasView.yoxdur') }}
                    </option>
                    <option value="yes">
                      {{ $t('offerExtrasView.qiymtDaxildir') }}
                    </option>
                    <option value="paid">
                      {{ $t('offerExtrasView.qiymtDaxilDeyil') }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow">
          <div class="card-body">
            <div
              v-if="requestType !=='OFR'"
              class="mb-3 w-50"
            >
              <label v-if="request.requestType==='POL'">{{ $t('newPolRequest.ssvermNSonTarix') }}</label>
              <label v-else-if="['REV','AUC','LOG','RFQ'].indexOf(request.requestType)>-1">
                {{ $t('newRFQRequest.tklifNSonTarix') }}
              </label>
              <label v-else>{{ $t('newInfoRequest.sorununBitmTarixi') }}</label>

              <DatePicker
                v-model="requestDeadline"
                mode="dateTime"
                is24hr
                :minute-increment="15"
                :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                :min-date="minDeadline"
                :is-required="true"
                :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
              >
                <template #default="{ inputValue, inputEvents }">
                  <input
                    type="text"
                    class="form-control "
                    :value="inputValue"
                    placeholder=""
                    required
                    v-on="inputEvents"
                  >
                </template>
              </DatePicker>
            </div>

            <div
              v-if="requestType === 'PQT' && requestDeadline "
              class="mb-3 w-50"
            >
              <label>{{ $t('newRFQRequest.qalibinElanOlunmaTarixi') }}</label>

              <DatePicker
                v-model="orderExtras.winnerDeadline"
                mode="dateTime"
                is24hr
                :minute-increment="15"
                :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                :min-date="requestDeadline"
                :is-required="true"
                :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
              >
                <template #default="{ inputValue, inputEvents }">
                  <input
                    type="text"
                    class="form-control "
                    :value="inputValue"
                    placeholder=""
                    required
                    v-on="inputEvents"
                  >
                </template>
              </DatePicker>
            </div>

            <div
              v-if="['LOG','RFQ','TRS','TRK','REV','AUC'].indexOf(request.requestType)===-1"
              class="mb-3"
            >
              <label>{{ $t('newInfoRequest.lavFayllar') }}</label> <br>
              <p>{{ $t('newInfoRequest.sorunuzlaBalLavFayllarYklyBilrsiniz') }}</p>

              <div class="d-flex">
                <button
                  type="button"
                  class="btn btn-sm btn-light-primary"
                  @click.prevent="selectPhoto(-1)"
                >
                  {{ $t('newInfoRequest.yeniFaylYkl') }}
                </button>
                <div
                  v-if="uploadProgress >0 && uploadProgress <100"
                  class="progress"
                >
                  <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="{width: `${uploadProgress}%`}"
                  />
                </div>
              </div>
              <div
                v-if="requestFiles.length>0"
                class="w-50 mt-3"
              >
                <div
                  v-for="(f,i) in requestFiles"
                  :key="f.path"
                  class="requestFile py-1"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <a
                        :href="getPhoto(f.path,'')"
                        class="text-secondary"
                      >
                        <i class="fa fa-paperclip mr-1" />
                        {{ f.path.split('/').pop() }}
                      </a>
                    </div>

                    <div
                      class="d-flex align-items-center cursor-pointer"
                      href="#"
                      @click="deleteFile(i)"
                    >
                      <feather
                        type="x"
                        size="16"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="['OFR'].indexOf(request.requestType)===-1">
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-success">
                  <b-form-checkbox
                    v-model="requestIsPrivate"
                    :disabled="onlyVendors>0"
                    value="1"
                  >
                    {{ $t('newAUCRequest.mllifiGizlt') }} <br>

                    <span
                      v-if="requestIsPrivate"
                      class="text-danger"
                    >
                      {{ $t('newAUCRequest.mllifiDigrIstifadilrYalnzMzakiryBalayarsaGrcklr') }}
                    </span>
                    <span
                      v-else
                      class="text-success"
                    >
                      {{ $t('newAUCRequest.mllifiBtnIstifadilrGrcklr') }}
                    </span>
                  </b-form-checkbox>
                </div>
                <div
                  v-if="requestType==='PQT'"
                  class="d-flex flex-column  mt-2 mt-sm-0 p-3"
                  style="margin-left: 16rem; !important; border: 1px solid #2062fb"
                >
                  <h4>{{ $t("newRFQRequest.kotirovkaMetodunuSein") }}</h4>
                  <div class="checkbox checkbox-primary">
                    <b-form-checkbox
                      v-model="autoWinner"
                      value="1"
                    >
                      {{ $t('newAUCRequest.manual') }}
                    </b-form-checkbox>
                  </div>
                  <div class="checkbox checkbox-primary mt-2">
                    <b-form-checkbox
                      v-model="autoWinner"
                      value="2"
                    >
                      {{ $t('newAUCRequest.automatic') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="requestType !=='OFR'"
              class=" "
            >
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-success ">
                  <b-form-checkbox
                    v-model="requestIsPersonalAllowed"
                    value="1"
                  >
                    {{ $t('editRequest.frdiVensizXslrSorunuCavablayaBilsinmi') }}
                  </b-form-checkbox>
                </div>
                <div
                  v-if="requestType === 'PQT'"
                  class="d-flex flex-column  mt-2 mt-sm-0 p-3"
                  style="margin-left: 11rem;"
                >
                  <div class="checkbox checkbox-primary">
                    <b-form-checkbox
                      v-model="orderExtras.showBefore"
                      value="true"
                    >
                      {{ $t('newRFQRequest.showBefore') }}
                    </b-form-checkbox>
                  </div>
                  <div class="checkbox checkbox-primary mt-2">
                    <b-form-checkbox
                      v-model="orderExtras.alternativeRequired"
                      value="true"
                    >
                      {{ $t('newRFQRequest.alternativeOffer') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="['RFQ','PQT','REV','LOG','LGI','TRS','CSI','WHI'].indexOf(requestType)>-1">
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-success">
                  <b-form-checkbox
                    v-model="onlyVendors"
                    value="1"
                    :disabled="!vendorManagementAvailable || requestIsPrivate>0 || filteredVendors===0"
                    @change="openModal"
                  >
                    <p @click.prevent="openModal">
                      {{ $t('newInfoRequest.ancaqTsdiqlnmiTdarklrimCavablayaBilsin') }}
                      <span
                        v-if="selectedVendorCount > 0"
                        style="color: #1ea6ec"
                      >
                        {{ $t('vendorSeilib', {selectedVendorCount: selectedVendorCount}) }}
                      </span>
                    </p>
                    <em
                      v-if="showSectorError"
                      style="color: red"
                    >{{ $t('sorguNSektorSemmisiz') }}</em>
                    <em
                      v-if="filteredVendorsError"
                      style="color: red"
                    >{{ $t('newRFQRequest.noVendor2') }}</em>
                    <br>
                    <span
                      v-if="!vendorManagementAvailable"
                      class="text-danger"
                    >
                      {{ $t('newInfoRequest.buFunksiyanIstifadEtmkN') }}
                      <strong>{{ $t('newInfoRequest.vendorManagement') }}</strong>
                      {{ $t('newInfoRequest.lavsiniAktivldirmlisniz') }}
                      <router-link :to="{name: 'addOnPage'}">{{ $t('newInfoRequest.aktivldir') }}</router-link>
                    </span>
                    <span
                      v-if="requestIsPrivate>0"
                      class="text-danger"
                    >
                      {{ $t('newInfoRequest.gizliSorularNBuFunskiyaAktivDeyil') }}
                    </span>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4>{{ $t('newAUCRequest.mhsullar') }}</h4>
              <button
                type="button"
                class="btn btn-sm btn-light-primary"
                @click.prevent="addNewProduct()"
              >
                {{ $t('newAUCRequest.yeniMhsulLavEt') }}
              </button>
            </div>

            <hr>

            <table class="table table-bordernone product-table">
              <thead>
                <tr>
                  <th>{{ $t('newAUCRequest.tip') }}</th>
                  <th>{{ $t('newRFQRequest.mhsulunXidmtinAd') }}</th>
                  <th>{{ $t('newAUCRequest.miqdar') }}</th>
                  <th>{{ $t('newRFQRequest.mhsulXidmtHaqqndaQeydlr') }}</th>
                  <th>{{ $t('newAUCRequest.lavFayl') }}</th>
                  <th>{{ $t('newAUCRequest.specialRequirements') }}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(p, i) in products"
                  :key="i"
                >
                  <td>
                    <span v-if="p.productType==='PRODUCT'">{{ $t('newAUCRequest.mhsul') }}</span>
                    <span v-else-if="p.productType==='SERVICE'">{{ $t('newAUCRequest.xidmt') }}</span>
                    <span v-else>{{ p.productType }}</span>
                  </td>
                  <td class="can-wrap">
                    {{ p.name }}
                  </td>
                  <td>{{ p.count }} {{ p.unit }}</td>
                  <td class="can-wrap">
                    {{ p.note }}
                  </td>
                  <td>
                    <span v-if="p.photo">*.{{ p.photo.split('.').pop() }}</span>
                    <span v-else>-</span>
                  </td>
                  <td class="can-wrap">
                    <ul>
                      <li
                        v-for="(req, index) in p.requirements"
                        :key="`req-${index}`"
                      >
                        <span
                          v-if="req.mandatory"
                          class="text-danger"
                        >*</span>
                        {{ `${index + 1}. ` }}{{ req.requirement }}
                      </li>
                    </ul>
                  </td>
                  <td class="text-right">
                    <button
                      type="button"
                      class="btn btn-sm p-2 btn-light-success"
                      @click="editProduct(i)"
                    >
                      <feather
                        type="edit-3"
                        size="12"
                      />
                      {{ $t('newAUCRequest.dzliEt') }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm p-2 btn-light-danger ml-2"
                      @click="deleteProduct(i)"
                    >
                      <feather
                        type="x"
                        size="12"
                      />
                    </button>
                  </td>
                </tr>
                <tr
                  v-if="products.length < 1"
                  class="not-found"
                >
                  <td colspan="7">
                    <div class="alert alert-warning">
                      {{ $t('newAUCRequest.mhsulLavEdilmyib') }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mb-3">
          <button class="btn  btn-primary">
            {{ $t('sectorSelectionModal.yaddaSaxla') }}
          </button>
          <button
            type="button"
            class="btn  btn-light ml-2"
            @click.prevent="$router.go(-1)"
          >
            {{ $t('companyProfile.lvEt2') }}
          </button>
        </div>
      </form>


      <b-modal
        id="modal-sector-selection"
        centered
        :title="$t('companyProfile.faliyytSahsiniSein')"
        scrollable
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="false"
        class="theme-modal"
        :busy="false"
        :hide-footer="true"
      >
        <sector_selection_modal
          :parent-sector="null"
          :selected="requestSectors"
          :max-selection="5"
          @done="($event)=>{requestSectors = $event;$bvModal.hide('modal-sector-selection') }"
        />
      </b-modal>
    </div>
    <div v-else>
      <div class="alert alert-info">
        {{ $t('login.yklnir') }}
      </div>
    </div>
    <!-- Container-fluid Ends-->
    <b-modal
      id="modal-edit-product"
      size="xl"
      centered
      :title="$t('newAUCRequest.mhsul')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="true"
      class="theme-modal"
      :hide-footer="true"
    >
      <form @submit.prevent="saveProduct">
        <div
          v-if="editingProductIndex>-1"
          class="card-body"
        >
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label>{{ $t('newAUCRequest.tip') }}</label>
                <select
                  v-model="editingProduct.productType"
                  class="form-control"
                  required
                >
                  <option value="PRODUCT">
                    {{ $t('newAUCRequest.mhsul') }}
                  </option>
                  <option value="SERVICE">
                    {{ $t('newAUCRequest.xidmt') }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label>{{ $t('newAUCRequest.mhsulunXidmtinAd') }}</label>
                <input
                  v-model="editingProduct.name"
                  class="form-control"
                  type="text"
                  required
                >
              </div>

              <div class="mb-3">
                <label>{{ $t('newAUCRequest.mhsulXidmtHaqqndaQeydlr') }}</label>
                <textarea
                  v-model="editingProduct.note"
                  class="form-control"
                  type="text"
                />
              </div>


              <div class="mb-3">
                <div class="row">
                  <div class="col-6">
                    <label>{{ $t('newAUCRequest.miqdar') }}</label>
                    <input
                      v-model="editingProduct.count"
                      class="form-control"
                      type="number"
                      step="0.01"
                      required
                    >
                  </div>
                  <div class="col-6">
                    <label>{{ $t('newAUCRequest.lVahidi') }}</label>
                    <select
                      v-if="editingProduct.productType==='SERVICE'"
                      v-model="editingProduct.unit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in serviceUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                    <select
                      v-else
                      v-model="editingProduct.unit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in productUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label>{{ $t('newAUCRequest.lavFayl') }}</label> <br>

              <div v-if="editingProduct.photo">
                <img
                  v-if="isPhoto(editingProduct.photo)"
                  :src="getPhoto(editingProduct.photo,'mediumCropped')"
                  alt=""
                  class="img-thumbnail"
                  style="max-height: 300px; max-width: 100%;"
                >
                <div
                  v-else
                  class="p-3 border border-secondary rounded"
                >
                  *.{{ editingProduct.photo.split('.').pop() }} {{
                    $t('newRFQRequest.editingproductphotosplitpopFayl')
                  }}
                </div>
              </div>
              <div class="mt-2 ">
                <button
                  type="button"
                  class="btn btn-sm mr-2 btn-light-primary"
                  @click.prevent="selectPhoto(1)"
                >
                  {{ $t('newAUCRequest.ykl') }}
                </button>
                <button
                  v-if="editingProduct.photo"
                  type="button"
                  class="btn btn-sm  mr-2 btn-light-danger"
                  @click.prevent="editingProduct.photo=''"
                >
                  <i class="fa fa-trash" />
                </button>
                <br>
                <div v-if="requestType === 'PQT'">
                  <br>
                  <label>{{ $t('newAUCRequest.specialRequirements') }}</label>
                  <br>
                  <!-- Use the specialRequirements of the editingProduct -->
                  <div
                    v-for="(req, index) in editingProduct.requirements"
                    :key="index"
                    class="mb-2"
                  >
                    <div class="input-group">
                      <input
                        v-model="req.requirement"
                        type="text"
                        class="form-control"
                        required
                        :placeholder="$t('newAUCRequest.enterSpecialRequirement')"
                      >
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-danger"
                          type="button"
                          @click="removeSpecialRequirementFromProduct(index)"
                        >
                          <i class="fa fa-trash" />
                        </button>
                        <div class="form-check d-flex align-items-center ml-3">
                          <input
                            v-model="req.mandatory"
                            class="form-check-input"
                            type="checkbox"
                          >
                          <label
                            class="form-check-label ml-2"
                          >
                            {{ $t('newRFQRequest.mandatoryReply') }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    v-if="editingProduct.requirements?.length < 5"
                    type="button"
                    class="btn btn-outline-primary"
                    @click="addSpecialRequirementToProduct"
                  >
                    {{ $t('newAUCRequest.addSpecialRequirement') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-between">
              <button
                type="submit"
                class="btn btn-primary mr-3"
              >
                {{ $t('sectorSelectionModal.yaddaSaxla') }}
              </button>
              <button
                type="button"
                class="btn btn-light-danger"
                @click.prevent="cancelSaveProduct"
              >
                {{ $t('companyProfile.lvEt') }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="modal-vendors"
      centered
      size="lg"
      :title="$t('vndrlrScn')"
      scrollable
      class="theme-modal"
    >
      <button
        class="btn btn-primary btn-lg"
        style="margin-bottom: 20px"
        @click="selectAllVendors"
      >
        {{ $t('selectAll') }}
      </button>
      <div
        v-for="v in filteredVendors"
        class="list-group-item"
      >
        <div
          :key="v.id"
          class="row"
        >
          <div class="col-md-4 mb-3">
            <strong>{{ v.verifiedCompany.name }} {{ getCompanyFormat(v.verifiedCompany.format) }}</strong>
            <br>
            {{ $t('supplierOutgoingVendorRequest.ven') }} <em>{{ v.verifiedCompany.taxId }}</em><br>
          </div>
          <!-- Adding sector names -->
          <div class="col-md-12">
            <strong>{{ $t('sektorlari') }} </strong>
            <span
              v-for="sectorObj in v.sectors"
              :key="sectorObj.sector.id"
            >
              {{ sectorObj.sector.name }},
            </span>
          </div>

          <div class="col-md-8 mb-3">
            <div v-if="v.profileType==='LOGISTIC'">
              {{ $t('companyVendors.logistikSorularNTsdiqlnmidir') }}
            </div>

            <div v-if="v.profileType==='TRUCK'">
              {{ $t('companyVendors.trlarlaBalSorularNTsdiqlnmidir') }}
            </div>
          </div>
          <div class="col-md-12">
            {{
              $t('companyVendors.vcreatedbynameVcreatedbysurnameTrfindnNewDatevlogt', {
                name: v.createdBy.name,
                surname: v.createdBy.surname,
                time: getMoment(v.logTime)
              })
            }}
          </div>
          <b-form-checkbox
            class="col-md-12 checkbox checkbox-primary"
            :checked="isChecked(v.verifiedCompany.id)"
            @change="toggleChecked(v.verifiedCompany.id)"
          />
        </div>
      </div>
      <template #modal-footer>
        <div
          v-if="missingSectors.length > 0"
          class="alert alert-warning"
        >
          <strong>{{ $t('newRFQRequest.noVendorForThisSector') }}</strong>
          <ul>
            <li
              v-for="sector in missingSectors"
              :key="sector.id"
            >
              {{ sector.parent.name }}
            </li>
          </ul>
          <strong>{{ $t('newRFQRequest.deleteThisSector') }}</strong>
        </div>
        <button
          class="btn btn-secondary"
          @click="closeModal"
        >
          {{ $t('companyProfile.lvEt') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  addAddressCompany,
  deleteAddressCompany,
  editRequest,
  getCompanyAddresses,
  getRequestDetails,
  getVendorManagementStatus,
  getWorkingSectors,
  updateAddressCompany,
  upload
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';
import {buildLongId, deliveryTypes, getCompanyFormat, getPhoto, loadTypes, truckTypes} from "@/repositories/Utils";
import moment from 'moment'
import Sector_path from "@/components/sector_path.vue";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import dayjs from "dayjs";
import {getFormsBySectorIds, getVendorList} from "@/repositories/VendorManagementRepository";

export default {
  components: {
    SelectedSectorView,
    Sector_selection_modal,
    Sector_path,
    Multiselect, Datepicker
  },
  data() {
    return {
      missingSectors: [],// Sectors without vendor
      selectedCountry: [], // The selected country
      countryCodes: [], // This will hold the corresponding country codes
      showSectorError: false,
      forms:[],
      filteredVendorsError: false,
      allSelected: false,
      showVendors: false,
      filteredVendors: [],
      mediaBase: mediaBase,
      requestType: '',
      requestSubType: '',
      faq: [],
      request: null,
      requestTitle: '',
      requestDescription: '',
      requestIsPrivate: 0,
      requestIsPersonalAllowed: 0,
      onlyVerified: 0,
      onlyVendors: 0,
      requestDeadline: '',
      requestPhoto: '',
      autoWinner: '',
      editingProductIndex: -1,
      editingProduct: null,
      products: [],
      requestSectors: [],
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      sectors: [],
      vendorIds: [],
      uploadProgress: 0,
      requestFiles: [],
      orderExtras: {
        pickUpCountry: '',
        pickUpCity: '',
        pickUpAddress: '',
        dropOffCountry: '',
        dropOffCity: '',
        dropOffAddress: '',
        deadline: '',
        notes: '',
        incoterms: '',
        types: [],
        loadSize: '',
        loadUnit: '',
        startingPrice: 0,
        multiSelect: 0,
        ownVariant: 0
      },
      vendors:[],
      addressInput: "",
      formMode: "add", // 'add' or 'edit'
      editAddressId: null,
      savedAddresses: [],
      format: "dd MMM yyyy",
      inctermsList: ["EXW", "FOB", "CIF", "FCA", "DPU", "CFR", "CIP", "DAP", "DDP"],
      typeList: deliveryTypes(),
      advTypeList: loadTypes(),
      loadUnits: this.$t("loadUnits"),
      vendorManagementAvailable: false
    };
  },
  watch: {
    onlyVerified(newVal) {
      if (newVal) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("prtlHzrkMrhlRsmAdmnOlan"),
          icon: 'warning'
        })
      }
    },
    onlyVendors(newVal) {
      if (newVal) {
        this.onlyVendors = newVal;
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      profile: state => state.auth.profile,
    }),

    selectedVendorCount() {
      return this.vendorIds.length;
    },
    isChecked() {
      return (id) => this.vendorIds.includes(id);
    },
    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    },
    truckTypeList() {
      let list = [];
      Object.keys(truckTypes()).forEach((k) => {
        let v = truckTypes()[k];
        v.key = k;

        list.push(v);
      })
      return list;
    },
  },
  mounted() {
    this.fetchAddresses()
    getRequestDetails(this.token, this.$route.params.id).then(data => {

          if (data.code === 200) {
            if (data.request.user.id !== this.user.id || data.request.company.id !== this.company.id) {
              this.$swal({
                title: this.$t("err"),
                text: this.$t("ylnzOzSrgnlnDzl"),
                type: "warning"
              }).then(() => {
                this.$router.push({name: "request", params: {id: this.$route.params.id}});
              })
            } else {

              //setting field values
              this.request = data.request;
              this.requestType = data.request.requestType;
              this.requestSubType = data.request.requestSubType;
              this.requestSectors = data.sectors;
              this.showSectorError = false;
              let sectorIds = this.requestSectors.map(s => {
                return s.parent.id;
              });
              getFormsBySectorIds(this.token, sectorIds).then(data => {
                    this.forms = data;
                  }
              );
              this.vendorIds = data.selectedVendorIds;
              getVendorList(this.token).then((list) => {
                console.log(list)
                this.vendors = list;
              this.filteredVendors = this.filterVendorsBySectors(list, data.sectors);
              })
              this.missingSectors = this.findMissingSectors(this.filteredVendors);
              this.requestFiles = data.files;
              this.autoWinner = data.request.autoWinner;
              this.requestTitle = data.request.title;
              this.requestDescription = data.request.description;
              this.requestPhoto = data.request.photo;
              this.products = data.products;
              this.requestIsPrivate = data.request.private ? 1 : 0;
              this.requestIsPersonalAllowed = data.request.personalAllowed ? 1 : 0;
              this.onlyVendors = data.request.onlyVendors ? 1 : 0;
              this.onlyVerified = data.request.onlyVerified ? 1 : 0;
              this.requestDeadline = data.request.requestDeadline;

              let jsonExtras = JSON.parse(data.request.extras)
              this.orderExtras = {
                pickUpCountry: jsonExtras.pickupCountry,
                pickUpCity: jsonExtras.pickupCity,
                pickUpAddress: jsonExtras.pickupAddress,
                dropOffCountry: jsonExtras.dropOffCountry,
                dropOffCity: jsonExtras.dropOffCity,
                dropOffAddress: jsonExtras.dropOffAddress,
                deadline: moment(jsonExtras.offerDeadline).toDate(),
                notes: jsonExtras.notes,
                incoterms: jsonExtras.incoterms,
                loadSize: jsonExtras.volume,
                loadUnit: jsonExtras.unit,
                startingPrice: jsonExtras.startingPrice,
                ownVariant: jsonExtras.ownVariant,
                multiSelect: jsonExtras.multiSelect,
                minOrder: jsonExtras.minOrder,
                unit: jsonExtras.unit,
                price: jsonExtras.price,
                payment: jsonExtras.payment,
                delivery: jsonExtras.delivery,
                currency: jsonExtras.currency,
                currencyRequired: jsonExtras.currencyRequired,
                incotermsRequired: jsonExtras.incotermsRequired,
                paymentRequired: jsonExtras.paymentRequired,
                deliveryNeeded: jsonExtras.deliveryNeeded,
                initialRequirementNotes: jsonExtras.initialRequirementNotes,
                winnerDeadline: moment(jsonExtras.winnerDeadline).toDate(),
                truckType: '',
                driverHasAdr: jsonExtras.driverHasAdr,
                priceVolume: jsonExtras.priceVolume,
                pricePrice: jsonExtras.pricePrice,
                priceNotes: jsonExtras.priceNotes,
                countryRequired: jsonExtras.countryRequired,
                deliveryAddress: jsonExtras.deliveryAddress,
                deliveryTimeNeeded: jsonExtras.deliveryTimeNeeded,
                alternativeRequired: jsonExtras.alternativeRequired,
                showBefore: jsonExtras.showBefore,
                guarantyTime: jsonExtras.guarantyTime,
              };

              if (jsonExtras.types) {
                let l = jsonExtras.types.split(',')

                if (this.request.requestType === 'TRK') {
                  this.orderExtras.types = this.advTypeList.filter(t => {
                    return l.indexOf(t.key) > -1
                  })
                } else if (this.request.requestType === 'LOG') {
                  this.orderExtras.types = this.typeList.filter(t => {
                    return l.indexOf(t.key) > -1
                  })
                }
              }

              if (jsonExtras.truckType) {
                this.orderExtras.truckType = truckTypes()[jsonExtras.truckType];
              }

            }
          } else {
            this.$swal({
              title: this.$t("err"),
              text: `${data.message}`,
              type: "warning"
            }).then(() => {
              this.$router.push({name: "request", params: {id: this.$route.params.id}});
            })

          }

        }
    )
    getWorkingSectors(this.$i18n.locale).then(data => {
      this.sectors = data;
    })
    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = (code === 200);
    })
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-vendors');
    },

    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY')
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    toggleChecked(id) {
      const index = this.vendorIds.indexOf(id);
      if (index === -1) {
        this.vendorIds.push(id);
      } else {
        this.vendorIds.splice(index, 1);
      }
      this.allSelected = this.vendorIds.length === this.vendors.length;
    },
    async findMissingSectors(requestSectors) {
      const selectedSectorIds = requestSectors.map(sector => sector.parent.id);

      const missingSectorIds = selectedSectorIds.filter(sectorId => {
        return !this.filteredVendors.some(vendor => {
              return vendor.sectors.some(sectorObj => sectorObj.sector.id === sectorId)
            }
        );
      });

      return this.requestSectors.filter(sector => missingSectorIds.includes(sector.parent.id));
    },
    openModal() {
      if (this.requestSectors.length === 0) {
        this.showSectorError = true;
        this.onlyVendors = 0;
      } else if (this.filteredVendors.length === 0) {
        this.filteredVendorsError = true;
        this.onlyVendors = 0;
      } else if (this.forms.length !== 0) {
        this.$bvModal.show('modal-vendors')
      } else if (this.onlyVendors) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.sektorTedarukcu"),
          icon: 'warning',
          confirmButtonText: this.$t("companyFormEdit.yarat"),
          allowOutsideClick: true
        }).then((create) => {
          if (create.isConfirmed) {
            window.open('/dashboard/vendorManagement/forms', '_blank');
          }
        });
      }
    },
    addSpecialRequirementToProduct() {
      if (this.editingProduct.requirements?.length < 5) {
        this.editingProduct.requirements.push({text: '', mandatory: false});

      } else {
        alert('Yalniz 5 ədəd xususi tələb əlavə edə bilərsiz');
      }
    },
    addNewProduct() {

      this.products.push({
        name: '',
        note: '',
        count: '',
        unit: '',
        photo: '',
        requirements: [] // Initialize an empty array for special requirements
      })

      this.editProduct(this.products.length - 1);
    },
    deleteProduct(index) {
      this.products.splice(index, 1)
    },
    editProduct(index) {
      this.editingProductIndex = index;
      this.editingProduct = JSON.parse(JSON.stringify(this.products[index]));
      this.$bvModal.show('modal-edit-product');
    },
    saveProduct() {
      this.editingProduct.requirements = this.editingProduct.requirements.filter(req => req.requirement.trim() !== '');
      this.products.splice(this.editingProductIndex, 1, this.editingProduct);
      this.$bvModal.hide('modal-edit-product');
      this.editingProductIndex = -1;
      this.editingProduct = null;
    },
    cancelSaveProduct() {
      let lastItem = this.products[this.editingProductIndex];
      if (lastItem.productType === '' || lastItem.name === '' || lastItem.count < 1 || lastItem.unit === '') {
        this.products.splice(this.editingProductIndex, 1);
      }
      this.$bvModal.hide('modal-edit-product');
      this.editingProductIndex = -1;
      this.editingProduct = null;
    },
    fetchAddresses() {
      getCompanyAddresses(this.token, this.company.id).then(
          response => {

            this.savedAddresses = response;
          }
      )

    },
    handleSubmit() {
      if (!this.addressInput.trim()) return;

      if (this.formMode === "add") {
        this.addAddress();
      } else {
        this.updateAddress();
      }

      this.resetForm();

    },
    addAddress() {
      addAddressCompany(this.token, this.company.id, this.addressInput).then(
          response => {


            this.$bvToast.toast("Addres uğurla əlavə edildi", {variant: "success"});
            this.fetchAddresses();
          }
      );
    },
    updateAddress() {
      updateAddressCompany(this.token, this.editAddressId, this.addressInput).then(
          response => {
            this.$bvToast.toast("Addres uğurla dəyisdirildi", {variant: "success"});
            this.fetchAddresses();
          }
      )

    },
    deleteAddress(id) {
      if (!confirm("Addresi silməyə əminsiz?")) return;
      deleteAddressCompany(this.token, id).then(
          response => {
            this.$bvToast.toast("Addres silindi", {variant: "success"});
            this.fetchAddresses();
          }
      );

    },
    editAddress(address) {
      this.formMode = "edit";
      this.editAddressId = address.id;
      this.addressInput = address.address;
    },
    resetForm() {
      this.formMode = "add";
      this.editAddressId = null;
      this.addressInput = "";
    },
    selectAddress(address) {
      this.orderExtras.deliveryAddress = address.address;
      this.$bvModal.hide('modal-address-history-edit');
    },
    validateSelection() {
      if (this.autoWinner === null || this.autoWinner === false) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: `${this.$t("newRFQRequest.kotirovkaMetodunuSein")}`,
          icon: 'error'
        })
        return false;
      }
      // Proceed with form submission or next steps
      return true;
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    filterVendorsBySectors(vendorsArray, sectorsArray) {
      const sectorIds = sectorsArray.map(sector => sector.parent.id); // Extract ids of sectors in the 2nd array
      return vendorsArray.filter(vendor => {
        return vendor.sectors.some(sector => sectorIds.includes(sector.sector.id));
      });
    },
    createRequest() {
      if (this.requestType === 'PQT' && !this.validateSelection())
        return;
      let sectors = this.requestSectors.map(function (elem) {
        return elem.id;
      }).join(",");
      switch (this.request.requestType) {
        case "LGI":
        case "LOG":
        case "TRS":
          sectors = 13;
          break;
        case "CSI":
          sectors = 14;
          break;
        case "WHI":
          sectors = 12;
          break;
        case "OFR":
          if (this.profile === 'LOGISTIC') {
            sectors = 13;
          }
          break;

      }

      let extras = {};
      if (this.request.requestType === 'PQT') {
        let winnerDeadlineFormatted = moment(this.orderExtras.winnerDeadline).format('YYYY-MM-DD HH:mm:ss');

        extras = {
          "version": "1.0.0",
          "currency": this.orderExtras.currency,
          "currencyRequired": this.orderExtras.currencyRequired,
          "incoterms": this.orderExtras.incoterms,
          "incotermsRequired": this.orderExtras.incotermsRequired,
          "payment": this.orderExtras.payment,
          "paymentRequired": this.orderExtras.paymentRequired,
          "deliveryAddress": this.orderExtras.deliveryAddress,
          "showBefore": this.orderExtras.showBefore,
          "alternativeRequired": this.orderExtras.alternativeRequired,
          "deliveryNeeded": this.orderExtras.deliveryNeeded,
          "deliveryTimeNeeded": this.orderExtras.deliveryTimeNeeded,
          "guarantyTime": this.orderExtras.guarantyTime,
          "countryRequired": this.orderExtras.countryRequired,
          "delivery": `${this.orderExtras.delivery}`,
          "initialRequirementNotes": this.orderExtras.initialRequirementNotes,
          "winnerDeadline": winnerDeadlineFormatted
        };
      } else if (this.request.requestType === 'AUC') {

        extras = {
          "version": "1.0.0",
          "startingPrice": this.orderExtras.startingPrice
        };
      } else if (this.request.requestType === 'POL') {
        extras = {
          "version": "1.0.0",
          "multiSelect": this.orderExtras.multiSelect,
          "ownVariant": this.orderExtras.ownVariant
        };
      } else if (this.request.requestType === 'LOG') {
        let deadlineFormatted = moment(this.requestDeadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "pickupAddress": this.orderExtras.pickUpAddress,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "dropOffAddress": this.orderExtras.dropOffAddress,
          "offerDeadline": deadlineFormatted,
          "notes": this.orderExtras.notes,
          "incoterms": this.orderExtras.incoterms,
          "types": this.orderExtras.types.map((t) => {
            return t.key;
          }).join(","),
        };
      } else if (this.request.requestType === 'TRS') {
        let deadlineFormatted = moment(this.orderExtras.deadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "pickupAddress": this.orderExtras.pickUpAddress,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "dropOffAddress": this.orderExtras.dropOffAddress,
          "offerDeadline": deadlineFormatted,
        };
      } else if (this.request.requestType === 'TRK') {

        let deadlineFormatted = moment(this.orderExtras.deadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "volume": this.orderExtras.loadSize,
          "unit": this.orderExtras.loadUnit,
          "offerDeadline": deadlineFormatted,
          "types": this.orderExtras.types.map((t) => {
            return t.key;
          }).join(","),
          truckType: this.orderExtras.truckType.key,
          driverHasAdr: this.orderExtras.driverHasAdr,
          priceVolume: this.orderExtras.priceVolume,
          pricePrice: this.orderExtras.pricePrice,
          priceNotes: this.orderExtras.priceNotes,
        };
      } else if (this.requestType === 'OFR') {

        if (this.requestSubType === 'wholesale') {
          extras = {
            "version": "1.0.0",
            "minOrder": this.orderExtras.minOrder,
            "unit": this.orderExtras.unit,
            "price": this.orderExtras.price,
            "payment": this.orderExtras.payment,
            "delivery": this.orderExtras.delivery,
          };
        } else if (this.requestSubType === 'retail') {
          extras = {
            "version": "1.0.0",
            "payment": this.orderExtras.payment,
            "delivery": this.orderExtras.delivery,
          };
        } else if (this.requestSubType === 'service') {
          extras = {
            "version": "1.0.0",
            "payment": this.orderExtras.payment,
          };
        }

      }


      if (this.requestTitle !== '' && (['LOG', 'TRS', 'TRK'].indexOf(this.request.requestType) > -1 || this.requestDescription !== '') && sectors !== '') {

        editRequest(
            this.token, this.request.id,
            sectors,
            this.requestTitle, this.requestFiles, this.requestDescription,
            this.requestDeadline,
            this.requestIsPrivate, this.requestIsPersonalAllowed,
            this.onlyVerified, this.onlyVendors,
            JSON.stringify(extras), this.autoWinner,
            this.products,
            this.vendorIds
        ).then(data => {

          if (data.code === 200) {

            this.$router.replace('/dashboard/request/' + this.request.id);

          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        })

      }

    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    deleteFile(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.requestFiles.splice(index, 1);
      }
    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'requestPhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                this.requestFiles.push({
                  id: 0,
                  path: response.data.path,
                  type: "request"
                });

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {

              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    selectAllVendors() {
      if (this.allSelected) {
        // If all are already selected, unselect all
        this.vendorIds = [];
      } else {
        // Otherwise, select all vendors
        this.vendorIds = this.vendors.map(v => v.verifiedCompany.id);
      }
      this.allSelected = !this.allSelected; // Toggle the flag
    },
  }

}
</script>

<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.selectable-address {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 5px; /* istəyə bağlı */
}

.selectable-address:hover {
  background-color: #0f37da; /* Bootstrap primary rəngi */
  color: #fff; /* mətnin oxunaqlılığını artırmaq üçün */
}
</style>
